/**
 * Effect Runs — list (read-only, `[PROPOSED]`).
 *
 * `frontend-entity-coverage §2.3`: EffectRun is PROPOSED, backed by
 * `/api/effect-runs` (`11 §2.1`), normally shown inside the RuleRun trace but
 * also addressable on its own. No primary verb beyond inspection. Discoverable
 * labeled-empty teaser until the endpoint ships.
 */
import { Zap } from "@/components/ui/icon";

import { ProposedListPage } from "../_shared/ProposedModule";

export function EffectRunList() {
  return (
    <ProposedListPage
      title="Effect Runs"
      description="One record per effect a rule fired — surfaced inside each Rule Run trace."
      icon={Zap}
      endpoint="/api/effect-runs"
      emptyTitle="No effect runs yet"
      testId="effect-runs-empty"
    />
  );
}

export default EffectRunList;
